export const EMAIL_REGEXP = new RegExp(/^[\w]{1,}[\w.+-]{0,}@[\w-]{1,}([.][a-zA-Z]{2,}|[.][\w-]{2,}[.][a-zA-Z]{2,})$/);
export const PHONE_REGEXP = new RegExp(/^[0-9]+$/);
export const URL_REGEXP = new RegExp(
  /((http|https):\/\/)(www.|[a-z0-9-_])?[a-z0-9-_]+(\.[a-z]{2,}){0,3}(#?\/?[a-zA-Z0-9#-_]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%_]+&?)?$/,
);
